import { LayoutContext } from 'layouts/LayoutContext';
import { useContext } from 'react';

const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  return context;
};

export default useLayoutContext;
